<template>
  <VueSidePanel v-model="isSidePanelOpen" transition-name="slide-left" width="42%" side="left"
    body-class="bbSidePanelBody bbSidePanelBody-Skill" panel-color="transparent" :z-index="5000">
    <template #default>
      <div class="mt-2 px-4">
        <SkillCard :skill="skill" :activeTab="activeTab" :character="character" :max_skill="max_skill"
          @add-character-skill="$emit('add-character-skill', $event)" 
          @update-character-skill="$emit('update-character-skill', $event)" 
          @delete-character-skill="$emit('delete-character-skill', $event)" 
          @close-skill-panel="$emit('close-skill-panel', $event)" />
      </div>
    </template>
  </VueSidePanel>
</template>

<script>
import SkillCard from './SkillCard.vue'
import { VueSidePanel } from 'vue3-side-panel'
//---------
// scripts
//---------
export default {
  name: 'SkillSidePanel',
  emits: ['add-character-skill', 'update-character-skill', 'delete-character-skill', 'close-skill-panel'],
  //------------
  // components
  //------------
  components: {
    VueSidePanel,
    SkillCard,
  },
  //-------
  // props
  //-------
  props: {
    skill: {
      type: Object,
      required: false,
      default: null,
    },
    activeTab: {
      type: String,
      required: true,
    },
    character: {
      type: Object,
      required: true,
      default: null,
    },
    max_skill: {
      type: Number,
      required: true,
    },
  },
  //------
  // data
  //------
  data() {
    return {
      isSidePanelOpen: true, // mandatory for VueSidePanel
    }
  },
  //---------
  // methods
  //---------
  methods: {},
  //---------
  // mounted
  //---------
  mounted() {
  },
}
</script>

<style scoped>
.vsp-overlay {
  background: #1e1e1e !important;
  opacity: 0.2 !important;
}
</style>